import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  modal: {
    backgroundColor: theme?.palette?.primaryBG?.[400]
  },
  modalheader: {
    padding: "1rem",
    backgroundColor: theme?.palette?.casinoSearch?.primaryBG,
    position: "sticky"
  }
}));
